<script setup lang="ts">
import { currentUserQueryOptions, useDynamicUserUpdates, userInjectionKey } from '#shared'
import { useQuery } from '@tanstack/vue-query'
import { provide } from 'vue'
import { useDynamicChatUpdates } from '#entities/chat'
import { useDynamicMessageUpdates } from '#entities/message'
import Alerts from './alerts.vue'
import Conversations from './conversations.vue'
import MainChat from './main-chat.vue'

useDynamicMessageUpdates()
useDynamicChatUpdates()
useDynamicUserUpdates()

const currentUserQuery = useQuery(currentUserQueryOptions)
const currentUser = currentUserQuery.data

provide(userInjectionKey, currentUser)
</script>

<template>
  <Alerts />
  <Conversations />
  <MainChat />
</template>
